import axios from 'axios';
import { mutate } from 'swr';

import { GridSelectionModel } from '@mui/x-data-grid-pro';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

const dealPath = `/${SERVICES.DEAL}/deals/shipments`;
const documentPath = `/${SERVICES.DOCUMENT}/shipmentBatch`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const requestCreateReadytoship = (shippingData: any) => {
  return mutate(documentPath, async() => {
    try {
      await axios.post(documentPath, shippingData);
      Notistack.successMessage('Deal Ready To Ship - Record Created Successfully');
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};

export const requestDeleteDealShipments = (selectedShipments: GridSelectionModel) => {
  return mutate(dealPath, async() => {
    try {
      await axios.delete(dealPath, {
        headers: {
          'Content-Type': 'application/json',
        },
        data: selectedShipments,
      });
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};

export const requestGetShipmentFileData = async(path: string) => {
  try {
    const resp = await axios.get(`${documentPath}/blobPath?blobPath=${path}`);

    return resp;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};
